// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e1c2b30d","845":"419ea29d"}[chunkId] + ".chunk.js";
};